import { FireProofDoorsStatus, FireSecurityUnitInfoDto, SmokeDetectorsOnEveryFloorStatus } from "shared/types/fire-security";

// Calculate the date for 3 months from now
const threeMonthsFromNow = new Date();
threeMonthsFromNow.setMonth(threeMonthsFromNow.getMonth() + 3);

const nineMonthsBefore = new Date();
nineMonthsBefore.setMonth(nineMonthsBefore.getMonth() - 9);

const twelveMonthsBefore = new Date();
twelveMonthsBefore.setMonth(twelveMonthsBefore.getMonth() - 12);



export const calculateFireSecurityUnitDotValues = (fireSecurityUnitInfo: FireSecurityUnitInfoDto) => {
    let dotValues: any = {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    };

    // Transparent values
    if (!fireSecurityUnitInfo || !fireSecurityUnitInfo.fireProofDoors || fireSecurityUnitInfo.fireProofDoors === FireProofDoorsStatus.UNKNOWN) {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Onbekende status van brandwerende deuren");
    }
    if (!fireSecurityUnitInfo || !fireSecurityUnitInfo.smokeDetectorsOnEveryFloorStatus || fireSecurityUnitInfo.smokeDetectorsOnEveryFloorStatus === SmokeDetectorsOnEveryFloorStatus.UNKNOWN) {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Onbekende status van rookmelders op elke verdieping");
    }

    // Orange values
    if (!fireSecurityUnitInfo || !fireSecurityUnitInfo.smokeDetectorsOnEveryFloorStatus || fireSecurityUnitInfo.smokeDetectorsOnEveryFloorStatus === SmokeDetectorsOnEveryFloorStatus.PARTIAL) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Gedeeltelijke aanwezigheid van rookmelders op elke verdieping");
    }
   
    // Red values
    if (fireSecurityUnitInfo.fireProofDoors === FireProofDoorsStatus.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Brandwerende deuren niet in orde");
    }
    if (fireSecurityUnitInfo.smokeDetectorsOnEveryFloorStatus === SmokeDetectorsOnEveryFloorStatus.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Geen rookmelders op elke verdieping");
    }

    // Green values
    if (fireSecurityUnitInfo.fireProofDoors === FireProofDoorsStatus.OK) {
        dotValues.green.count++;
        dotValues.green.labels.push("Brandwerende deuren in orde");
    }
    if (fireSecurityUnitInfo.fireProofDoors === FireProofDoorsStatus.NOT_REQUIRED) {
        dotValues.green.count++;
        dotValues.green.labels.push("Brandwerende deuren niet vereist");
    }
    if (fireSecurityUnitInfo.smokeDetectorsOnEveryFloorStatus === SmokeDetectorsOnEveryFloorStatus.OK) {
        dotValues.green.count++;
        dotValues.green.labels.push("Rookmelders aanwezig op elke verdieping");
    }

    return dotValues;
};
